<template>
    <div>
        <modal :show.sync="pymeCost" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Fuente Captura de Información</h6>  
                <div class="row">
                    <div v-if="pymeMessage != null" class="alert alert-info">
                        <span>El valor actual del sistema es:<strong> {{ pymeMessage }}</strong></span>
                    </div>  
                    <p-button @click="saveCostsPymeData('Estados financieros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Estados financieros
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Software contable')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Software contable
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Registros en excel')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Registros en excel
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Libros contables')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Libros contables
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Otros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Otros
                    </p-button>
                </div>
                <template slot="footer">
                    <div class="left-side">
                        <p-button type="default" link @click="cancelAddRoute()">Cancelar</p-button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        
                    </div>
                </template>       
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
            </div>
            <div class="card-body text-center">
                <div class="row">
                    <p-button @click="toGeneralData()" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Costo general
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="toAccountingData()" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Costo información contable
                    </p-button>
                </div>
                <div v-if="!$store.state.assesmentEditing" class="row">
                    <p-button @click="toSalesCostsSelection()" type="block btn-default">
                        <i slot="label" class="fa fa-arrow-left mr-3"></i>
                        Volver
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
    </div>
</template>
<script>
    import { Card, Modal } from 'src/components/UIComponents'
    export default {
        components: {
            Card,
            Modal
        },
        data() {
        return {
            pymeCost: false,
            pymeMessage: null
        }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setPymeCostsDescription (description) {
                this.$store.commit('updateCustomerPECosts', description)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddRoute () {
                this.pymeCost = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveCostsPymeData (description) {
                this.setPymeCostsDescription(description);
                this.$router.push('/asessments/new_asessment/customer/costs/business/pyme/general');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toItemData() {
                if (this.$store.state.isCustomer) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isSpouse) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isGuarantor) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                }
                if (subcategory == 'produccion') {
                    this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                }
                else {
                    // this.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             toAccountingData() {
                this.pymeCost = true;
                // if (this.$store.state.isCustomer) {
                //     var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                // }
                // else if(this.$store.state.isSpouse) {
                //     var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                // }
                // else if(this.$store.state.isGuarantor) {
                //     var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                // }
                // if (subcategory == 'produccion') {
                //     this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                // }
                // else {
                //     // this.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                // }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toGeneralData() {
                if (this.$store.state.isCustomer) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isSpouse) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                }
                else if(this.$store.state.isGuarantor) {
                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                }
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if (subcategory == 'produccion') {
                    this.$router.push('/asessments/new_asessment/customer/costs/production/general');
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/costs/business/general');
                }
                
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pe_costs || null;
            }
            else if(this.$store.state.isSpouse) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pe_costs || null;
            }
            else if (this.$store.state.isGuarantor) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pe_costs || null;
            }
        }
    }
</script>
<style>
</style>
